<template>
  <div>
    <v-flex class="pb-16">
      <div class="faq-container">
        <div v-for="(faq, index) in form.faqs" :key="index" class="faq-item">
          <div v-if="editingFaqs.includes(index)" class="faq-item-content">
            <h2 class="faq-item-content__title">Edit question</h2>
            <text-field
              v-model="faq.question"
              class="faq-item-question"
              autofocus
              :disabled="!editingFaqs.includes(index)"
              :validator="vs && vs.faqs.$each[index]['question']"
              :error-messages="{
                required: 'This field is required.',
              }"
              label="Question title:"
            />
            <text-field
              v-model="faq.answer"
              class="faq-item-answer"
              :disabled="!editingFaqs.includes(index)"
              :validator="vs && vs.faqs.$each[index]['answer']"
              :error-messages="{
                required: 'This field is required.',
              }"
              label="Question answer:"
            />
          </div>
          <div v-else class="faq-item-content">
            <p>Q: {{ faq.question }}</p>
            <p>A: {{ faq.answer }}</p>
          </div>
          <div class="faq-item-footer">
            <main-button flat @click.prevent="deleteFaq(index)">Delete</main-button>
            <div v-if="!editingFaqs.includes(index)">
              <main-button outline @click.prevent="editFaq(index)">
                <v-icon style="margin-right: 8px">edit</v-icon> Edit
              </main-button>
            </div>

            <div v-else class="faq-item-footer-actions" :column="$vuetify.breakpoint.xs">
              <main-button outline @click.prevent="cancelEditFaq(index)">Cancel</main-button>

              <main-button
                :disabled="vs.faqs.$each[index].$invalid || vs.faqs.$each[index].$error"
                @click.prevent="saveEditFaq(index)"
              >
                Save
              </main-button>
            </div>
          </div>
        </div>
      </div>
      <main-button flat @click.prevent="createFaq()">
        <v-icon style="margin-right: 8px">add</v-icon>
        ADD QUESTION
      </main-button>
    </v-flex>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  name: 'faq-form',
  components: {},
  props: {
    initialValues: {
      type: Object,
      default: () => ({ faqs: [] }),
    },
    vs: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: this.initialValues,
      editingFaqs: [],
      tempFaqs: {},
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  methods: {
    createFaq() {
      if (!this.form.faqs.length) {
        this.$set(this.form, 'faqs', [])
      }
      this.form.faqs.push({ question: '', answer: '' })
      const newIndex = this.form.faqs.length - 1
      this.editFaq(newIndex)
    },
    deleteFaq(index) {
      this.form.faqs.splice(index, 1)
      const editIndex = this.editingFaqs.indexOf(index)

      if (editIndex !== -1) {
        this.editingFaqs.splice(editIndex, 1)
        delete this.tempFaqs[index]
      }
    },
    editFaq(index) {
      this.$set(this.tempFaqs, index, cloneDeep(this.form.faqs[index]))
      if (!this.editingFaqs.includes(index)) {
        this.editingFaqs.push(index)
      }
    },
    cancelEditFaq(index) {
      this.$set(this.form.faqs, index, this.tempFaqs[index])

      const editIndex = this.editingFaqs.indexOf(index)
      if (editIndex !== -1) {
        this.editingFaqs.splice(editIndex, 1)
      }

      if (!this.tempFaqs[index] || !this.tempFaqs[index].answer || !this.tempFaqs[index].question) {
        this.deleteFaq(index)
      }
      delete this.tempFaqs[index]
    },
    saveEditFaq(index) {
      this.vs.$touch()
      if (this.vs.faqs.$each[index].$error) return

      delete this.tempFaqs[index]
      const editIndex = this.editingFaqs.indexOf(index)
      if (editIndex !== -1) {
        this.editingFaqs.splice(editIndex, 1)
      }
    },
  },
}
</script>

<style scoped>
.faq-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.faq-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #ffffff;
  border: 0.125rem solid #d9d9d9;
  border-radius: 0.5rem;
}

.faq-item-content {
  padding: 1.5rem 1.5rem;
  border-bottom: 0.125rem solid #d9d9d9;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 18px;
}

.faq-item-content .faq-item-content__title {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 0.5rem;
}
.faq-item-content p {
  color: #333333;
  margin: 0;
}
.faq-item-footer {
  display: flex;
  justify-content: space-between;
  padding: 1.5rem 1.5rem;
  color: #0277bd;
  font-size: 18px;
}

.faq-item-footer-actions {
  display: flex;
  flex-direction: column;
}

@media screen and (min-width: 1024px) {
  .faq-item-footer-actions {
    flex-direction: row;
  }
}
</style>
